module.exports = __webpack_public_path__ + "img/1171.fba46bb1.jpg";